import React from 'react';

import {
  VALIDATION_CONDITIONS,
  always,
  isRegisteringExpertOwner,
  never,
  onlyDEB,
  onlyHilfsbetrieb,
  onlyNE,
} from 'global/renderingValidationConstants';

export const DOCUMENT_NAME_TO_ID = {
  businessRegistrationChange: 13,
  liabilityInsuranceProof: 14,
  businessEquipmentConfirmation: 15,
  installerContract: 16,
  craftCard: 17,
  commercialRegisterExtract: 18,
  employmentProof: 20,
  installerContractGas: 21,
  trainingCertificateExtension: 22,
  employmentProofResponsible: 23,
  installerContractGasResponsible: 24,
  qualificationProofElectricity: 25,
  qualificationProofGas: 26,
  treiCertificateElectricity: 27,
  trgiCertificate2018: 28,
  trgiCertificate100h: 29,
  installerContractMeterEnergy: 30,
  installerContractMeterGas: 31,
  installerContractSealing: 32,

  masterCertificateElectrical: 70,
  masterCertificateAppendix: 71,
  safetyCertificate: 72,
  masterCertificate: 73,
  masterCertificateAppendix2: 74,
  specificProfessionalPracticeProof: 75,
  technicianDiploma: 76,
  securityAndMaintenanceCertificateGas: 77,
  qualificationProofExtension: 78,
  gridOperatorRegistration: 79,
};

export const SHARED_DOCUMENTS = {
  [DOCUMENT_NAME_TO_ID.businessRegistrationChange]: {
    id: DOCUMENT_NAME_TO_ID.businessRegistrationChange,
    title: 'Gewerbean-/ummeldung',
    documentName: 'Gewerbean-/ummeldung',
    name: 'businessRegistrationChange',
    isOptional: onlyHilfsbetrieb,
    uploadName: 'Date_Gewerbeanmeldung',
  },
  [DOCUMENT_NAME_TO_ID.liabilityInsuranceProof]: {
    id: DOCUMENT_NAME_TO_ID.liabilityInsuranceProof,
    title: 'Nachweis über das Bestehen einer Betriebshaftpflichtversicherung',
    documentName: 'Betriebshaftpflicht',
    infoText:
      'Mit ausgewiesenen Tätigkeitsfeld: Strom/Gas sowie mit Angabe von der Versicherungssumme bei Personen- und Sachschäden',
    name: 'liabilityInsuranceProof',
    isOptional: never,
    uploadName: 'Date_Versicherung',
  },
  [DOCUMENT_NAME_TO_ID.businessEquipmentConfirmation]: {
    id: DOCUMENT_NAME_TO_ID.businessEquipmentConfirmation,
    title:
      'Selbstbestätigung Betriebsausstattung (mit Unterschrift der verantwortlichen Fachkraft)',
    documentName: 'Betriebsausstattung',
    name: 'businessEquipmentConfirmation',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    uploadName: 'Date_Betriebsausstattung',
  },
  [DOCUMENT_NAME_TO_ID.installerContract]: {
    id: DOCUMENT_NAME_TO_ID.installerContract,
    title: 'Installateurvertrag',
    documentName: 'Installateurvertrag',
    name: 'installerContract',
    infoText: <>Hier finden Sie eine passende Vorlage</>,
    isOptional: never,
    uploadName: 'Date_Installateurvertrag_Gas',
  },
  [DOCUMENT_NAME_TO_ID.craftCard]: {
    id: DOCUMENT_NAME_TO_ID.craftCard,
    title: 'Handwerkskarte',
    documentName: 'Handwerkskarte',
    name: 'craftCard',
    infoText: <>(Vorder- und Rückseite – im Scheckkartenformat)</>,
    isOptional: never,
    whenShouldFieldRender: {
      type: VALIDATION_CONDITIONS.NOT,
      condition: onlyHilfsbetrieb,
    },
    uploadName: 'Date_HWK',
  },
  [DOCUMENT_NAME_TO_ID.commercialRegisterExtract]: {
    id: DOCUMENT_NAME_TO_ID.commercialRegisterExtract,
    title: 'Handelsregisterauszug',
    documentName: 'Handelsregisterauszug',
    name: 'commercialRegisterExtract',
    isOptional: always,
    uploadName: 'Date_HRA',
  },
  [DOCUMENT_NAME_TO_ID.gridOperatorRegistration]: {
    id: DOCUMENT_NAME_TO_ID.gridOperatorRegistration,
    title:
      'Installateurausweis - Nachweis der Eintragung bei Ihrem zuständigen Stamm-Netzbetreiber',
    documentName: 'Installateurausweis',
    name: 'gridOperatorRegistration',
    isOptional: never,
    uploadName: 'Date_installateurnummer_Gastausweis',
    infoText: (
      <>
        Falls Sie keinen Ausweis mit Ihren aktuellen Daten haben, laden Sie Ihren alten Ausweis
        hoch, um den Antrag abzusenden. Reichen Sie zeitnah den aktualisierten Ausweis nach.
      </>
    ),
    infoTextNE: <>Bitte laden Sie Ihren aktuellen Installateurausweis hoch.</>,
  },
  [DOCUMENT_NAME_TO_ID.employmentProof]: {
    id: DOCUMENT_NAME_TO_ID.employmentProof,
    title: 'Anstellungsnachweis der verantwortlichen Fachkraft',
    documentName: 'Anstellungsnachweis',
    name: 'employmentProof',
    infoText: (
      <>
        Nachweis der Weisungsbefugnis, z.B. mittels Anstellungsvertrag, Auszug Sozialversicherung,
        Bestätigung des Betriebsinhabers, Betriebsleitererklärung - von Ihrer verantwortlichen
        Fachkraft / Ihren verantwortlichen Fachkräften, wenn diese nicht gleichzeitig Inhaber bzw.
        Geschäftsführer der Firma ist / sind.
      </>
    ),
    isOptional: never,
    uploadName: 'Date_Anstellungsnachweis_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.installerContractGas]: {
    id: DOCUMENT_NAME_TO_ID.installerContractGas,
    title: 'Installateurvertrag mit Unterschrift der verantwortlichen Fachkraft/Fachkräfte (Gas)',
    documentName: 'Installateurvertrag (Gas)',
    name: 'installerContractGas',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    uploadName: 'Date_Installateurvertrag_Gas_Fachkraft',
  },
  [DOCUMENT_NAME_TO_ID.trainingCertificateExtension]: {
    id: DOCUMENT_NAME_TO_ID.trainingCertificateExtension,
    title: 'Fortbildungsnachweise zur Ausweisverlängerung',
    documentName: 'Fortbildungsnachweise',
    infoText: (
      <>
        z.B. Schulungen zu DIN-Normen, VDE-Bestimmungen, VDE-Anwendungsregeln und/oder den TAB -
        bitte für jede Fachkraft hochladen
        <br />
        Übersicht Vorraussetzungen
      </>
    ),
    name: 'trainingCertificateExtension',
    isOptional: never,
    uploadName: 'Date_Fortbildungsnachweis',
  },

  [DOCUMENT_NAME_TO_ID.installerContractMeterEnergy]: {
    id: DOCUMENT_NAME_TO_ID.installerContractMeterEnergy,
    title: 'Vertrag "Zählermontage durch Installateure" Strom',
    documentName: 'Vertrag Zählermontage Strom',
    name: 'installerContractMeterEnergy',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    whenShouldFieldRender: {
      type: VALIDATION_CONDITIONS.OR,
      conditions: [
        {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [{ type: VALIDATION_CONDITIONS.NOT, condition: onlyHilfsbetrieb }, onlyNE],
        },
        onlyDEB,
      ],
    },
    uploadName: 'Date_Vertrag_ZDI_Strom',
  },
  [DOCUMENT_NAME_TO_ID.installerContractMeterGas]: {
    id: DOCUMENT_NAME_TO_ID.installerContractMeterGas,
    title: 'Vertrag "Zählermontage durch Installateure" Gas',
    documentName: 'Vertrag Zählermontage Gas',
    name: 'installerContractMeterGas',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    whenShouldFieldRender: {
      type: VALIDATION_CONDITIONS.OR,
      conditions: [
        {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [{ type: VALIDATION_CONDITIONS.NOT, condition: onlyHilfsbetrieb }, onlyNE],
        },
        onlyDEB,
      ],
    },
    uploadName: 'Date_Vertrag_ZDI_Gas',
  },
  [DOCUMENT_NAME_TO_ID.installerContractSealing]: {
    id: DOCUMENT_NAME_TO_ID.installerContractSealing,
    title: 'Vertrag "Nachplombierung"',
    documentName: 'Vertrag "Nachplombierung"',
    name: 'installerContractSealing',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    whenShouldFieldRender: {
      type: VALIDATION_CONDITIONS.OR,
      conditions: [
        {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [{ type: VALIDATION_CONDITIONS.NOT, condition: onlyHilfsbetrieb }, onlyNE],
        },
        onlyDEB,
      ],
    },
    uploadName: 'Date_Vertrag_Nachplombierung',
  },

  // experts documents
  [DOCUMENT_NAME_TO_ID.employmentProofResponsible]: {
    id: DOCUMENT_NAME_TO_ID.employmentProofResponsible,
    title: 'Anstellungsnachweis der verantwortlichen Fachkraft',
    documentName: 'Anstellungsnachweis',
    name: 'employmentProofResponsible',
    infoText: (
      <>
        Nachweis der Weisungsbefugnis, z.B. mittels Anstellungsvertrag, Auszug Sozialversicherung,
        Bestätigung des Betriebsinhabers, Betriebsleitererklärung - von Ihrer verantwortlichen
        Fachkraft / Ihren verantwortlichen Fachkräften, wenn diese nicht gleichzeitig Inhaber bzw.
        Geschäftsführer der Firma ist / sind.
      </>
    ),
    isOptional: never,
    whenShouldFieldRender: {
      type: VALIDATION_CONDITIONS.OR,
      conditions: [
        {
          type: VALIDATION_CONDITIONS.AND,
          conditions: [
            { type: VALIDATION_CONDITIONS.NOT, condition: isRegisteringExpertOwner },
            onlyNE,
          ],
        },
        onlyDEB,
      ],
    },
    uploadName: 'Date_Anstellungsnachweis_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.installerContractGasResponsible]: {
    id: DOCUMENT_NAME_TO_ID.installerContractGasResponsible,
    title: 'Installateurvertrag mit Unterschrift der verantwortlichen Fachkraft/Fachkräfte (Gas)',
    documentName: 'Installateurvertrag (Gas)',
    name: 'installerContractGasResponsible',
    infoText: <>Eine Vorlage dazu finden Sie in diesem Dokument</>,
    isOptional: never,
    uploadName: 'Date_Installateurvertrag_Gas_Fachkraft',
  },
  [DOCUMENT_NAME_TO_ID.qualificationProofElectricity]: {
    id: DOCUMENT_NAME_TO_ID.qualificationProofElectricity,
    title: 'Qualifikationsnachweis(e) Strom',
    documentName: 'Qualifikationsnachweis Strom',
    name: 'qualificationProofElectricity',
    isOptional: never,
    infoText: 'Hilfestellung dazu finden Sie in diesem Dokument',
    uploadName: 'Date_Quali_Strom_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.qualificationProofGas]: {
    id: DOCUMENT_NAME_TO_ID.qualificationProofGas,
    title: 'Qualifikationsnachweis(e) Gas',
    documentName: 'Qualifikationsnachweis(e) Gas',
    name: 'qualificationProofGas',
    isOptional: never,
    infoText: 'Hilfestellung dazu finden Sie in diesem Dokument',
    uploadName: 'Date_Quali_Gas_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.treiCertificateElectricity]: {
    id: DOCUMENT_NAME_TO_ID.treiCertificateElectricity,
    title:
      'Sachkundennachweis für den Anschluss elektrischer Anlagen und Geräte an das Niederspannungsnetz (Technische Regeln Elektro-Installationen; TREI)',
    documentName: 'Sachkundennachweis TREI',
    name: 'treiCertificateElectricity',
    infoText: 'Wenn vorhanden, bitte mitsenden, sofern nicht in Meisterprüfung enthalten.',
    isOptional: never,
    uploadName: 'Date_TREI_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.trgiCertificate2018]: {
    id: DOCUMENT_NAME_TO_ID.trgiCertificate2018,
    title:
      'Sachkundennachweis TRGI 2018: 1 Tageslehrgang für Fackkraft Qualifikation von 2018 (wird individuell geprüft und ggf. nachgefordert)',
    documentName: 'Sachkundennachweis TRGI 2018',
    name: 'trgiCertificate2018',
    infoText: 'Wenn vorhanden, bitte mitsenden, sofern nicht in Meisterprüfung enthalten.',
    isOptional: always,
    uploadName: 'Date_TRGI_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.trgiCertificate100h]: {
    id: DOCUMENT_NAME_TO_ID.trgiCertificate100h,
    title: 'Sachkundennachweis TRGI (100 Std.)',
    documentName: 'Sachkundennachweis TRGI',
    name: 'trgiCertificate100h',
    infoText:
      'Bitte TRGI Zertifikat hochladen. Schulungen oder Vorbereitungskurse ohne Prüfungsbescheinigung werden nicht anerkannt.',
    isOptional: never,
    uploadName: 'Date_TRGI_100h_firstname_lastname',
  },

  [DOCUMENT_NAME_TO_ID.masterCertificateElectrical]: {
    id: DOCUMENT_NAME_TO_ID.masterCertificateElectrical,
    title: 'Meisterprüfungszeugnis in einem Elektrohandwerk',
    documentName: 'Meisterprüfungszeugnis',
    name: 'masterCertificateElectrical',
    isOptional: never,
    uploadName: 'Date_Meister_Elektro_firstname_lastname',
  },
  // new fields
  [DOCUMENT_NAME_TO_ID.masterCertificateAppendix]: {
    id: DOCUMENT_NAME_TO_ID.masterCertificateAppendix,
    title:
      'Anhang zum Meisterprüfungszeugnis (Meisterprüfung nach welchem Meisterprüfungsverordnung abgelegt)',
    documentName: 'Anhang Meisterprüfungszeugnis',
    name: 'masterCertificateAppendix',
    isOptional: never,
    uploadName: 'Date_Anhang_Meisterpruefungszeugnis_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.safetyCertificate]: {
    id: DOCUMENT_NAME_TO_ID.safetyCertificate,
    title:
      'Sicherheitsschein - Ergebnis vom Fach "Elektro- und Sicherheitstechnik" (Teil B bzw. Teil 2 der Meisterprüfung)',
    documentName: 'Sicherheitsschein',
    infoText: (
      <div>
        Bescheinigung nach § 7 Abs. 6 ElektroTechMSTRV bzw. § 6 Abs. 6 InformationsTechMstrV
        ElektroMbMstrV von 2002 <b>oder</b> <br />
        Bescheinigung nach § 12 Absatz 4 der ElektroTechMstrV von 2024
      </div>
    ),
    name: 'safetyCertificate',
    isOptional: never,
    uploadName: 'Date_Sicherheitsschein_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.masterCertificate]: {
    id: DOCUMENT_NAME_TO_ID.masterCertificate,
    title: 'Meisterprüfungszeugnis Sparte Gas',
    documentName: 'Meisterprüfungszeugnis Gas',
    name: 'masterCertificate',
    isOptional: never,
    uploadName: 'Date_Meisterpruefungszeugnis_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.masterCertificateAppendix2]: {
    id: DOCUMENT_NAME_TO_ID.masterCertificateAppendix2,
    title: 'Anhang zum Meisterprüfungszeugnis',
    documentName: 'Anhang Meisterprüfungszeugnis',
    name: 'masterCertificateAppendix2',
    isOptional: never,
    uploadName: 'Date_Anhang_Meisterpruefungszeugnis_Gas_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.specificProfessionalPracticeProof]: {
    id: DOCUMENT_NAME_TO_ID.specificProfessionalPracticeProof,
    title: 'Nachweis von fachspezifischer Berufspraxis gemäß TRGI',
    documentName: 'Berufspraxisnachweis',
    name: 'specificProfessionalPracticeProof',
    isOptional: never,
    uploadName: 'Date_Berufspraxis_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.technicianDiploma]: {
    id: DOCUMENT_NAME_TO_ID.technicianDiploma,
    title: 'Techniker-/Diplomurkunde',
    documentName: 'Techniker-/Diplomurkunde',
    name: 'technicianDiploma',
    isOptional: never,
    uploadName: 'Date_Techniker_Diplomurkunde_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.securityAndMaintenanceCertificateGas]: {
    id: DOCUMENT_NAME_TO_ID.securityAndMaintenanceCertificateGas,
    title: 'Bescheinigung zum Fach Sicherheits- und Instandhaltungstechnik (Gas)',
    documentName: 'Sicherheit/Instandhaltung Gas',
    name: 'securityAndMaintenanceCertificateGas',
    isOptional: never,
    uploadName: 'Date_Gas-Besch_SuI-Technik_firstname_lastname',
  },
  [DOCUMENT_NAME_TO_ID.qualificationProofExtension]: {
    id: DOCUMENT_NAME_TO_ID.qualificationProofExtension,
    title: 'Fortbildungsnachweise zur Ausweisverlängerung',
    documentName: 'Fortbildungsnachweise',
    infoText: (
      <>
        z.B. Schulungen zu DIN-Normen, VDE-Bestimmungen, VDE-Anwendungsregeln und/oder den TAB
        <>
          <br />
          Übersicht Vorraussetzungen
        </>
      </>
    ),

    name: 'qualificationProofExtension',
    isOptional: never,
    uploadName: 'Date_Fortbildungsnachweis_firstname_lastname',
  },
};
